/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';

/**
 * 
 * @export
 * @interface StoreLocation
 */
export interface StoreLocation {
    /**
     * 
     * @type {string}
     * @memberof StoreLocation
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreLocation
     */
    isPrimaryLocation?: boolean;
    /**
     * 
     * @type {Address}
     * @memberof StoreLocation
     */
    address?: Address;
    /**
     * 
     * @type {number}
     * @memberof StoreLocation
     */
    id?: number;
    /**
     *
     * @type {number}
     * @memberof StoreLocation
     */
    courierId?: number;
    /**
     * Hex color code for visual identification (e.g. #FF5733)
     * @type {string}
     * @memberof StoreLocation
     */
    colorCode?: string | null;
    /**
     * Short identifier code for this store location, usable as the {LOCATION_CODE} token in shipping address templates (e.g. KGN, MOB)
     * @type {string}
     * @memberof StoreLocation
     */
    code?: string | null;
    /**
     * Latitude of the store, for the staff clock-in geofence (null clears it)
     * @type {number}
     * @memberof StoreLocation
     */
    latitude?: number | null;
    /**
     * Longitude of the store, for the staff clock-in geofence (null clears it)
     * @type {number}
     * @memberof StoreLocation
     */
    longitude?: number | null;
    /**
     * Radius in meters within which staff can clock in (default 100)
     * @type {number}
     * @memberof StoreLocation
     */
    clockInRadiusMeters?: number | null;
}

// MySQL DECIMAL columns can arrive as strings
function toOptionalNumber(value: any): number | undefined {
    if (value == null || value === '') return undefined;
    const n = Number(value);
    return Number.isFinite(n) ? n : undefined;
}

/**
 * Check if a given object implements the StoreLocation interface.
 */
export function instanceOfStoreLocation(value: object): value is StoreLocation {
    return true;
}

export function StoreLocationFromJSON(json: any): StoreLocation {
    return StoreLocationFromJSONTyped(json, false);
}

export function StoreLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'isPrimaryLocation': json['isPrimaryLocation'] == null ? undefined : json['isPrimaryLocation'],
        'address': json['address'] == null ? undefined : AddressFromJSON(json['address']),
        'id': json['id'] == null ? undefined : json['id'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'colorCode': json['colorCode'] == null ? undefined : json['colorCode'],
        'code': json['code'] == null ? undefined : json['code'],
        'latitude': toOptionalNumber(json['latitude']),
        'longitude': toOptionalNumber(json['longitude']),
        'clockInRadiusMeters': toOptionalNumber(json['clockInRadiusMeters']),
    };
}

export function StoreLocationToJSON(json: any): StoreLocation {
    return StoreLocationToJSONTyped(json, false);
}

export function StoreLocationToJSONTyped(value?: StoreLocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'isPrimaryLocation': value['isPrimaryLocation'],
        'address': AddressToJSON(value['address']),
        'id': value['id'],
        'courierId': value['courierId'],
        'colorCode': value['colorCode'],
        'code': value['code'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'clockInRadiusMeters': value['clockInRadiusMeters'],
    };
}

